let template = {}

export function clearDefaultData() {
  template = {}
}

export function setDefaultData(key, value) {
  Object.assign(template, { [key]: value })
}

export function getDefaultData(key) {
  return template?.[key]
}

export function handleError(key, value) {
  const data = JSON.parse(localStorage.getItem('Error') || '{}')
  if (data[key] !== value) {
    Object.assign(data, { [key]: value })
    localStorage.setItem('Error', JSON.stringify(data))
    window.location.reload()
  }
}
